import { Platform } from 'react-native';

export const isWeb = Platform.OS === 'web';
export const isMobile = Platform.OS === 'ios' || Platform.OS === 'android';

export const handleWebStorage = async (imageUrl: string) => {
  if (isWeb) {
    // For web, we'll use the browser's download capability
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = 'image.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  }
  return false;
};

export const handleWebNotifications = async () => {
  if (isWeb) {
    try {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  }
  return false;
};

export const showWebNotification = (title: string, body: string) => {
  if (isWeb && 'Notification' in window) {
    new Notification(title, {
      body,
      icon: '/icon-192.png'
    });
  }
}; 